import React from "react";
import { Heart, CarFront, Clock4 } from "lucide-react";

const SENIOR_IMG =
  "https://images.unsplash.com/photo-1581579438747-104c53e7c7ed?crop=entropy&cs=srgb&fm=jpg&ixid=&ixlib=rb-4.1.0&q=85&w=1200";

const BENEFITS = [
  {
    icon: Heart,
    title: "Osobní přístup",
    text: "S trpělivostí a úctou ke každému klientovi.",
  },
  {
    icon: CarFront,
    title: "Vyřídíme vše za vás",
    text: "Vyzvedneme auto i doklady přímo u vás doma.",
  },
  {
    icon: Clock4,
    title: "Ušetříte čas i starosti",
    text: "Žádné fronty, formuláře ani zbytečné cestování.",
  },
];

export default function ForSeniors() {
  return (
    <section
      id="pro-seniory"
      data-testid="for-seniors-section"
      className="relative bg-[#0A0D17] text-white py-20 lg:py-24 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-amber-300/15 bg-gradient-to-br from-[#0A0D17] via-[#0A0D17] to-[#0E1730]">
          <div className="grid lg:grid-cols-2">
            <div className="relative order-2 lg:order-1 min-h-[260px] lg:min-h-full">
              <img
                src={SENIOR_IMG}
                alt="Senioři s autem"
                className="absolute inset-0 h-full w-full object-cover opacity-70"
              />
              <div className="absolute inset-0 bg-gradient-to-l from-[#0A0D17] via-[#0A0D17]/30 to-transparent" />
            </div>

            <div className="order-1 lg:order-2 p-8 lg:p-12 xl:p-14">
              <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/25 bg-amber-300/5 px-3 py-1 text-xs uppercase tracking-[0.2em] text-amber-300">
                <Heart className="h-3.5 w-3.5" />
                Pro seniory
              </div>
              <h2 className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-balance">
                Služby pro seniory
              </h2>
              <p className="font-body mt-5 text-lg text-slate-300 leading-relaxed max-w-xl">
                Pomáháme seniorům se vším, co se týká jejich vozidel. Vše vyřídíme
                za vás — s trpělivostí, pochopením a úctou.
              </p>

              <div className="mt-8 grid sm:grid-cols-3 gap-4">
                {BENEFITS.map((b) => (
                  <div
                    key={b.title}
                    className="rounded-2xl border border-amber-300/15 bg-white/[0.03] p-5"
                  >
                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-300/10 border border-amber-300/20 text-amber-300">
                      <b.icon className="h-4 w-4" />
                    </div>
                    <div className="font-heading mt-4 text-base font-bold text-white">
                      {b.title}
                    </div>
                    <p className="mt-1 text-xs text-slate-400 leading-relaxed">
                      {b.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
